import styled from 'styled-components';

const mobileBreakPoint = '1000px';

export const CardsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 40px;

  @media screen and (max-width: ${mobileBreakPoint}) {
	flex-direction: column;
	align-items: center;
	gap: 22px;
  }
`

export const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 33.3%;

  h3 {
	color: #595959;
	font-family: Barlow, sans-serif;
	font-size: 25px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 20px;
	margin-bottom: 24px;
	text-transform: capitalize;
  }

  h4 {
	align-self: flex-end;
	color: #595959;
	font-family: Barlow, sans-serif;
	font-size: 22px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: 16px;
	margin-top: 18px;
  }

  @media screen and (max-width: ${mobileBreakPoint}) {
	width: 100%;
	align-items: center;
	max-width: 380px;

	h3 {
	  align-self: flex-start;
	  font-size: 18px;
	  line-height: 16px;
	  margin-bottom: 18px;
	}

	h4 {
	  display: none;
	}
  }
`

interface IProps {
	image?: string
}

export const CardWrapper = styled.div<IProps>`
  position: relative;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  width: 100%;
  padding: 14px 12px 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("${props => props.image}") no-repeat 0 0;
  background-size: cover;
  min-height: 242px;
  justify-content: space-between;

  @media screen and (max-width: 1000px) {
	min-height: unset;
  }
`;

export const CardLogo = styled.img`
  height: 35px;
  width: auto;
  margin-bottom: 16px;

  @media screen and (max-width: ${mobileBreakPoint}) {
	height: 25px;
	margin-bottom: 10px;
  }
`;
export const CardTitle = styled.div`
  color: #FFFFFF;
  font-family: Champion, sans-serif;
  font-size: 33px;
  letter-spacing: 0;
  line-height: 33px;
  text-align: center;
  text-transform: uppercase;

  span {
	color: #FEC600;
  }

  @media screen and (max-width: ${mobileBreakPoint}) {
	font-size: 24px;
	line-height: 24px;
  }
`;
export const CardTimer = styled.div`
  position: relative;
  z-index: 2;
  color: #FEC600;
  font-family: Champion, sans-serif;

  letter-spacing: 0;
  margin: 0 0 10px 0;
  font-weight: 700;

  > div {
	width: unset;
	font-size: 20px;
	position: relative;
	margin-top: 0;
	line-height: 0;

	> div {
	  font-size: 33px;
	  color: #FFFFFF;
	  position: relative;
	  top: 4px;
	  right: 1px;
	  padding: 0 4px;
	  font-weight: 500;
	}
  }
`;

export const CardButton = styled.button`
  position: relative;
  z-index: 3;
  border-radius: 2px;
  background-color: #FEC600;
  border: none;
  padding: 10px 16px;
  text-transform: uppercase;
  pointer-events: none;

  color: #1C1C1C;
  font-family: Barlow, sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2.57px;
  line-height: 14px;
  cursor: pointer;

  &.completed {
	margin-top: 48px;
	cursor: default;
	pointer-events: none;
	font-weight: bold;
	letter-spacing: 0;
  }

  &.live {
	margin-top: 12px;
  }
`;

export const Time = styled.div`
  font-family: Champion, sans-serif;
  font-size: 33px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 33px;
  width: 136px;
  height: 50px;
  border-radius: 50%;
`;

export const RightImage = styled.img`
  position: absolute;
  right: -16px;
  bottom: 0;

  @media screen and (max-width: ${mobileBreakPoint}) {
	width: 110px !important;
  }
`;

export const LeftImage = styled.img`
  position: absolute;
  left: -16px;
  bottom: 0;;
`

export const CompletedText = styled.h4`
  font-family: Champion, sans-serif !important;
  padding-top: 12px;
  font-size: 28px !important;
  color: #FFFFFF !important;
  text-transform: uppercase;
  font-weight: bold !important;

  @media screen and (max-width: ${mobileBreakPoint}) {
	font-size: 22px !important;
  }
`

export const LiveText = styled(CompletedText)``

interface ICardLogoProps {
	spbtw: boolean;
}
export const CardLogoWrapper = styled.div<ICardLogoProps>`
  display: flex;
  justify-content: ${props => props.spbtw ? "space-between" : "center"};
  width: 100%;

  img {
	height: 33px;
	width: auto;
  }
`;
